/**
 * Where in the examinations the address points.
 *
 * The area's own reading of `route.path`, kept beside the area rather than in the frame — the frame
 * only cares how deep the address is, and what the steps mean is this area's business.
 *
 * Four places, and each of them is a link somebody can send:
 *
 *   `#/exams`                     the tests
 *   `#/exams/new`                 setting one
 *   `#/exams/<id>`                one test: its tasks and its sittings
 *   `#/exams/<id>/edit`           changing that test
 *   `#/exams/attempts/<id>`       one sitting — writing it, and reading the judgement afterwards
 */
export const EXAMS_AREA = 'exams'

export interface OpenedExam {
  /** The test that is open, or `null`. */
  readonly examId: string | null
  /** Whether that test is being changed rather than read. */
  readonly editing: boolean
  /** Whether a new test is being set. */
  readonly creating: boolean
  /** The sitting that is open, or `null`. */
  readonly attemptId: string | null
}

export function openedIn(path: readonly string[]): OpenedExam {
  const [first, second] = path

  if (first === 'new') {
    return { examId: null, editing: false, creating: true, attemptId: null }
  }
  if (first === 'attempts') {
    return { examId: null, editing: false, creating: false, attemptId: second ?? null }
  }
  if (first === undefined) {
    return { examId: null, editing: false, creating: false, attemptId: null }
  }
  return { examId: first, editing: second === 'edit', creating: false, attemptId: null }
}

/** Where one sitting lives, as the address says it. */
export function attemptPath(attemptId: string): string[] {
  return ['attempts', attemptId]
}
